// Enviro free implementation of `hubspot-url-utils`.

import * as Hublets from '../hublets';
import { Subdomains } from '../subdomains';

type Environment = 'prod' | 'qa';
type HubletPostfixLocation = 'subdomain' | 'domain';

export interface OverrideConfig {
  domainOverride?: string;
  envOverride?: Environment;
  hubletOverride?: string;
  hubletPostfixLocation?: HubletPostfixLocation;
  tldOverride?: string;
  hubletizeNa1?: boolean;
}

export function getHubletPostfix(
  hublet: string,
  overrideConfig?: OverrideConfig
): string {
  const hasHubletOverride = overrideConfig && overrideConfig.hubletOverride;

  const hubletToUse = hasHubletOverride
    ? overrideConfig.hubletOverride!
    : hublet;

  const hubletizeNa1 = overrideConfig && overrideConfig.hubletizeNa1 === true;

  if (hubletToUse === Hublets.na1 && !hubletizeNa1) {
    return '';
  }

  return `-${hubletToUse}`;
}

export function getSubDomain(
  hublet: string,
  prefix: string,
  overrideConfig?: OverrideConfig
): string {
  const hasHubletPostfixOverride =
    overrideConfig &&
    overrideConfig.hubletPostfixLocation &&
    overrideConfig.hubletPostfixLocation === 'domain';

  if (hasHubletPostfixOverride) {
    return prefix;
  }

  if (prefix === Subdomains.APP_API) {
    prefix = Subdomains.APP;
  }

  return `${prefix}${getHubletPostfix(hublet, overrideConfig)}`;
}

export function getDomain(
  hublet: string,
  short: 'prod' | 'qa',
  overrideConfig?: OverrideConfig
) {
  const domainPrefix = getDomainPrefix(overrideConfig);
  const envPostfix = getEnvPostfix(short, overrideConfig);
  const hubletDomainPostfix = getHubletDomainPostfix(hublet, overrideConfig);

  return `${domainPrefix}${envPostfix}${hubletDomainPostfix}`;
}

export function getEnvPostfix(
  short: 'prod' | 'qa',
  overrideConfig?: OverrideConfig
) {
  const hasEnvOverride = overrideConfig && overrideConfig.envOverride;
  const envToUse = hasEnvOverride ? overrideConfig!.envOverride : short;

  if (envToUse === 'qa') {
    return 'qa';
  }

  return '';
}

export function getDomainPrefix(overrideConfig?: OverrideConfig) {
  const hasDomainOverride = overrideConfig && overrideConfig.domainOverride;
  if (hasDomainOverride) {
    return overrideConfig!.domainOverride;
  }

  return 'hubspot';
}

export function getHubletDomainPostfix(
  hublet: string,
  overrideConfig?: OverrideConfig
) {
  const hasHubletPostfixxOverride =
    overrideConfig &&
    overrideConfig.hubletPostfixLocation &&
    overrideConfig.hubletPostfixLocation === 'domain';

  if (!hasHubletPostfixxOverride) {
    return '';
  }

  return getHubletPostfix(hublet, overrideConfig);
}

export function getTld(overrideConfig?: OverrideConfig) {
  const hasTldOverride = overrideConfig && overrideConfig.tldOverride;

  if (hasTldOverride) {
    return overrideConfig!.tldOverride;
  }

  return 'com';
}

export function getPathPrefix(subDomainPrefix: string) {
  if (subDomainPrefix === Subdomains.APP_API) {
    return '/api';
  }
  return '';
}
